import { render } from "./AuthBanner.vue?vue&type=template&id=18128a86&scoped=true"
import script from "./AuthBanner.vue?vue&type=script&lang=js"
export * from "./AuthBanner.vue?vue&type=script&lang=js"

import "./AuthBanner.vue?vue&type=style&index=0&id=18128a86&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18128a86"]])

export default __exports__